import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-registEmail",
  "use": "icon-registEmail-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-registEmail\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3.334 6.176V5h13.333v1.177L10.001 9.88 3.334 6.176Zm-1.667.484V15.834c0 .46.373.833.834.833h15c.46 0 .833-.373.833-.834V4.168a.833.833 0 0 0-.834-.833h-15a.833.833 0 0 0-.833.833V6.66Zm15 1.423V15H3.334V8.083l5.857 3.254c.504.28 1.116.28 1.619 0l5.857-3.254Z\" fill=\"#4C556C\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol